var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-success"},[_c('div',{staticClass:"top"},[_c('p',[_vm._v(_vm._s(_vm.payResult))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }